// Typescript
import { camelToSnakeCase, to_var } from "../utils/to_var";

export function to_property(key, var_name, var_type, nullable = false) {
  return {
    name: var_name + "",
    type: `${var_type}${!nullable ? "" : "?"}`,
  };
}

const types = [
  "String",
  "String?",
  "bool",
  "bool?",
  "int",
  "int?",
  "double",
  "double?",
];

export function modelBrickhubParser(
  class_name,
  value,
  is_json = false,
  equatable = false,
  copyWith = false,
  style = "basic"
) {
  let _type = "";
  let _classes = [];
  let _variable_name;
  let _class_name;
  let _relations = [];
  let additionals = [];
  if (is_json) {
    additionals.push("json");
  }
  if (equatable) {
    additionals.push("equatable");
  }
  if (copyWith) {
    additionals.push("copyWith");
  }

  try {
    _variable_name = class_name;
    _class_name = camelToSnakeCase(class_name, true);
  } catch (e) {
    console.log(e);
  }

  if (value === null) {
    _type = "String";
  } else if (typeof value === "string") {
    _type = "String";
  } else if (typeof value === "boolean") {
    _type = "bool";
  } else if (typeof value === "number") {
    if (value % 1 === 0) {
      _type = "int";
    } else {
      _type = "double";
    }
  } else if (typeof value === "object") {
    if (Array.isArray(value)) {
      if (value.length === 0 || !value[0]) {
        _type = "List<String>";
      } else {
        const { _o_type, _o_classes } = modelBrickhubParser(
          _variable_name,
          value[0],
          is_json,
          equatable,
          copyWith,
          style
        );
        _type = `List<${_o_type}>`;

        if (!types.includes(_o_type)) {
          _type = `List<${to_var(_o_type, true)}>`;
          _relations.push({ name: to_var(_o_type, true) });
        }

        if (_o_classes.length > 0) {
          _classes = [..._o_classes, ..._o_classes];
        }
      }
    } else {
      _type = _class_name;

      let _properties = [];

      for (const key in value) {
        if (Object.prototype.hasOwnProperty.call(value, key)) {
          const data = value[key];
          const {
            _o_type,
            _o_classes,
            _o_variable_name,
            _o_relations,
          } = modelBrickhubParser(
            key,
            data,
            is_json,
            equatable,
            copyWith,
            style
          );
          _relations = [..._relations, ..._o_relations];
          if (!types.includes(_o_type) && !_o_type.includes("List<"))
            _relations.push({ name: to_var(_o_type, true) });

          const property = to_property(key, _o_variable_name, _o_type, false);
          _properties.push(property);
          if (_o_classes.length > 0) {
            _classes = [..._classes, ..._o_classes];
          }
        }
      }

      let final = {
        model_name: _class_name,
        properties: _properties,
        style,
      };

      if (_relations.length > 0) {
        final["relations"] = _relations;
      }

      if (additionals.length > 0) {
        final["additionals"] = additionals;
      }

      _classes.push(JSON.stringify(final, null, 1));
    }
  }

  return {
    _o_type: _type,
    _o_variable_name: _variable_name,
    _o_classes: [...new Set(_classes)],
    _o_relations: _relations,
  };
}
